export const MIN_SCREEN_WIDTH: { [key: string]: number } = {
  DESKTOP: 900,
};

export const LANGUAGE_CODES = ["ko", "en"];

export const IMAGE_COMPRESSION_OPTIONS = {
  maxSizeMB: 0.5,
};
